module.exports = __webpack_public_path__ + "static/img/hatopress-dandad.c5e8081.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workshops/hatopress-dandad.jpg
// module id = 178
// module chunks = 1